import { useState } from 'react';
import { Form, Button, FloatingLabel, Col, Row } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';
import { useRef } from 'react';
import { useHistory } from 'react-router';
import { submitTicket } from '../services/TicketService';
import { useAccount } from '../Context/AccountProvider';
import { FormFeedback } from './FormFeedback';
import { AccountPageHeader } from './AccountPageHeader';
import { PlusCircleFill } from 'react-bootstrap-icons';

export function CreateTicketForm() {
    const captchaRef = useRef(null);
    const { accountInfo } = useAccount();
    const history = useHistory();

    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [captchaResponse, setCaptchaResponse] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);

    if (!accountInfo.user) {
        return (
            <div className="ct-page">
                <AccountPageHeader
                    icon={<PlusCircleFill />}
                    title="New Ticket"
                    breadcrumbs={[{ to: '/tickets', label: 'Support Tickets' }]}
                />
                <p className="ct-no-char">You must create an in-game character before submitting a support ticket.</p>
            </div>
        );
    }

    async function handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        if (!captchaResponse) { setError('Please complete the captcha.'); return; }
        if (!subject.trim())  { setError('Please write a subject for your ticket.'); return; }
        if (!message.trim())  { setError('Please describe your issue in detail.'); return; }

        setError(null);
        setSubmitting(true);
        try {
            const ticketId = await submitTicket(subject, message, captchaResponse);
            if (!isNaN(ticketId)) history.push('/ticket/' + ticketId);
        } catch (err) {
            setError(err.message || 'Failed to submit ticket. Please try again.');
            captchaRef.current?.reset();
            setCaptchaResponse(null);
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className="ct-page">
            <AccountPageHeader
                icon={<PlusCircleFill />}
                title="New Ticket"
                description="Describe your issue and our staff will get back to you"
                breadcrumbs={[{ to: '/tickets', label: 'Support Tickets' }]}
            />

            <Form noValidate onSubmit={handleSubmit}>
                <Row>
                    <Col xs={12}>
                        <FloatingLabel controlId="support-subject" label="Subject" className="mb-3">
                            <Form.Control
                                type="text"
                                placeholder="Subject"
                                maxLength={70}
                                value={subject}
                                onChange={e => setSubject(e.target.value)}
                                disabled={submitting}
                            />
                        </FloatingLabel>
                    </Col>
                    <Col xs={12}>
                        <FloatingLabel controlId="support-request" label="Support Request" className="mb-3">
                            <Form.Control
                                as="textarea"
                                placeholder="Describe your issue"
                                maxLength={15000}
                                value={message}
                                onChange={e => setMessage(e.target.value)}
                                disabled={submitting}
                                style={{ height: '160px' }}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>
                <Row>
                    <Col className="center" xs={12}>
                        <FormFeedback type="error" message={error} />
                    </Col>
                    <Col className="center" xs={12}>
                        <ReCAPTCHA
                            className="register-captcha"
                            ref={captchaRef}
                            sitekey="6LdFauQdAAAAAGyoyHMjIaDeUQCOC7ewif0ENiXI"
                            onChange={setCaptchaResponse}
                            onExpired={() => setCaptchaResponse(null)}
                            onErrored={() => setCaptchaResponse(null)}
                        />
                    </Col>
                    <Col className="center" xs={12}>
                        <Button type="submit" disabled={submitting}>
                            {submitting ? 'Submitting…' : 'Submit Ticket'}
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}
